import { JobDayStatus } from './types';

export const JOB_DAY_STATUSES: JobDayStatus[] = ['scheduled', 'draft', 'overdue', 'completed'];

export const jobDayStatusStyle: Record<JobDayStatus, string> = {
  completed: 'border-primary-300 bg-primary-50 text-primary-700',
  overdue: 'border-warning-500 bg-warning-50 text-warning-700',
  draft: 'border-neutral-300 bg-neutral-300 text-white',
  scheduled: 'border-neutral-200 bg-white text-neutral-700',
};

export const jobDayCalendarStyle: Record<JobDayStatus | 'active', string> = {
  completed: '[&>button]:bg-primary-50 [&>button]:text-primary-700',
  overdue: '[&>button]:bg-warning-50 [&>button]:text-warning-700',
  draft: '[&>button]:bg-neutral-300 [&>button]:text-white',
  scheduled:
    '[&>button]:border [&>button]:border-neutral-300 [&>button]:bg-white [&>button]:text-neutral-800',
  active: '[&>button]:ring-2 [&>button]:ring-primary-500 [&>button]:font-bold',
};

export const jobDayTabStyle = {
  base: 'relative flex h-11 shrink-0 items-center gap-1.5 whitespace-nowrap rounded-t-lg border border-b-0 px-4 text-sm font-medium',
  idle: 'border-neutral-100 bg-neutral-50 text-neutral-500 hover:bg-neutral-100 hover:text-neutral-700',
  active: 'z-[1] border-neutral-200 bg-white font-bold text-neutral-700',
  unscheduled: 'border-dashed border-warning-500 bg-warning-50 text-warning-700',
  unscheduledActive: 'z-[1] border-dashed border-warning-500 bg-white font-bold text-warning-700',
};
